export default __webpack_public_path__ + "static/media/bullet-miniature.7aa16908.png";